export enum CreateOfferingTransactionType {
  /**
   * Used to create an OfferingTransaction for a user who has not completed account sign-up yet. We must invoke the
   * POST /trades/{id}/submit endpoint in order to associate the trade with the user after their account is created.
   */
  COMMIT = 'COMMIT',
  /**
   * Creates a reserved OfferingTransaction. NOTE this is currently not supported and we are looking to deprecate it.
   */
  RESERVE = 'RESERVE',
  /**
   * Creates an OfferingTransaction that is ready to sign for a user with an Account.
   */
  TRANSACT = 'TRANSACT',
}
